import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogActions,
  FormControl,
  DialogContent,
  DialogTitle,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Typography,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { useStyles } from "../style";
import { groupEditValidation, orgEditValidation } from "./validation";
// import { useValidation } from "../../../../components/validation";
import SelectComponent from "../../../../components/select";
import Calendar from "../../../../components/calendar";
import moment from "moment";
import useForm from "../../../../hooks/useForm";
import { GroupSelection } from "../../../../components/group-select";

const initialValues = {
  firstName: "",
  lastName: "",
  isAdmin: false,
  gender: "",
  dob: null,
  isNotificationOn: false,
  userPayer: "",
  groupIds: null,
};

function EditUser(props) {
  const { openEditUser, closeHandler, addHandler, loader, row, service, changePayerHandler, isGroupAdminMode, currentUser } = props;
  const { values, errors, handleChange, handleFormSubmit, setValues } = useForm(
    initialValues,
    isGroupAdminMode ? groupEditValidation : orgEditValidation,
    addHandler
  );
  const showAddAdmin = row["user_id"] !== currentUser?.user_id;
  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      userId: row.userId,
      firstName: row.first_name,
      lastName: row.last_name,
      isAdmin: row.isAdmin,
      gender: row.gender ?? "",
      dob: row.birth_date ? moment(row.birth_date) : null,
      userPayer: row.is_solo ? "user" : "org",
      groupIds: null,
    }));
  }, [row]);
  const classes = useStyles();

  // const { validation, validate, autoValidate, isValid } = useValidation(validationInput);
  // const [user, setUser] = useState(defaultUser);
  // console.log(user, "user");
  // const [clicked, setClicked] = useState(false);

  // useEffect(() => {
  //   setUser(defaultUser);
  //   let currentUser = {
  //     ...user,
  //     userId: row.userId,
  //     firstName: row.first_name,
  //     lastName: row.last_name,
  //     isAdmin: row.isAdmin,
  //     gender: row.gender ?? "",
  //     externalText: row.externalText ?? "",
  //     adminText: row.adminText ?? "",
  //   };
  //   if (row.birth_date) {
  //     currentUser["dob"] = moment(row.birth_date);
  //   } else {
  //     currentUser["dob"] = null;
  //   }
  //   if (row.externalText) {
  //     currentUser["userPayer"] = "external";
  //   } else {
  //     currentUser["userPayer"] = "internal";
  //   }
  //   validateInputs(row);
  //   setClicked(false);
  //   setUser(currentUser);
  // }, [row]);

  // function validateInputs(data) {
  //   var keys = [validation["firstName"], validation["lastName"]];
  //   var values = [row.first_name, row.last_name];
  //   if (data.birth_date) {
  //     keys.push(validation["dob"]);
  //     values.push(data.birth_date);
  //   }
  //   if (data.gender) {
  //     keys.push(validation["gender"]);
  //     values.push(data.gender);
  //   }
  //   validate(keys, values);
  // }

  // function handleAdd() {
  //   autoValidate(true);
  //   if (isValid) {
  //     addHandler(user);
  //   }
  // }

  // function handleAdmin(e) {
  //   setClicked(true);
  //   setUser({ ...user, isAdmin: e.target.checked ? "Yes" : "" });
  // }
  // function handleNotification(e) {
  //   setClicked(true);
  //   setUser({ ...user, isNotificationOn: e.target.checked ? "Yes" : "" });
  // }
  // function handleInputChange(field, value) {
  //   setUser({ ...user, [field]: value });
  //   validate(validation[field], value);
  // }

  // function handleDobChange(field, value) {
  //   setUser({ ...user, [field]: value });
  //   validate(validation[field], value.format("YYYY-MM-DD"));
  // }

  // function isAdminUser() {
  //   return user.isAdmin;
  // }

  async function handleUserPayerChange(e) {
    const newUserPayer = e.target.value;
    handleChange("userPayer", newUserPayer);
    const isChanged = await changePayerHandler(row.userId);
    if (isChanged === false) {
      handleChange("userPayer", row.is_solo ? "external" : "internal");
    }
  }
  console.log(values, "values");

  return (
    <div className={classes.root}>
      {loader && (
        <Grid container className={classes.loader} justify="center" alignItems="center" alignContent="center">
          <CircularProgress />
        </Grid>
      )}
      <Dialog open={openEditUser} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth classes={classes.dialog}>
        <DialogTitle id="form-dialog-title" className={classes.dialogHeader}>
          Edit User
        </DialogTitle>
        <DialogContent className={classes.paddingSpacer}>
          <FormControl fullWidth>
            <Grid container spacing={4} className={classes.miniFieldGridBottom}>
              <Grid item xs={6}>
                <TextField
                  autoFocus
                  id="firstname"
                  label="First name"
                  variant="outlined"
                  inputProps={{ maxLength: "100" }}
                  value={values.firstName}
                  type="text"
                  fullWidth
                  size="small"
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  // onBlur={(e) => validate(validation["firstName"], e.target.value)}
                  onChange={(e) => handleChange("firstName", e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="lastname"
                  label="Last name"
                  variant="outlined"
                  inputProps={{ maxLength: "100" }}
                  value={values.lastName}
                  type="text"
                  size="small"
                  fullWidth
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                  // onBlur={(e) => validate(validation["lastName"], e.target.value)}
                  onChange={(e) => handleChange("lastName", e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} className={classes.miniFieldGridBottom}>
              <Grid item xs={6}>
                <Calendar
                  label="DOB"
                  name="dob"
                  position="right"
                  fullWidth
                  value={values.dob}
                  error={!!errors.dob}
                  helperText={errors.dob}
                  otherProps={{ maxDate: new Date() }}
                  onChange={(date) => {
                    handleChange("dob", date.format("YYYY-MM-DD"));
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectComponent
                  value={values.gender}
                  label="Gender"
                  options={[
                    {
                      id: "Male",
                      name: "Male",
                    },
                    {
                      id: "Female",
                      name: "Female",
                    },
                    {
                      id: "Others",
                      name: "Others",
                    },
                  ]}
                  onChange={(e) => handleChange("gender", e.target.value)}
                />
              </Grid>
              {isGroupAdminMode ? null : (
                <Grid item xs={12}>
                  <GroupSelection service={service} name={"groupIds"} error={errors?.groupIds} handleChange={handleChange} user_id={row?.userId} />
                </Grid>
              )}
              {isGroupAdminMode || !showAddAdmin ? null : (
                <Grid item xs={12}>
                  <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                    User Role
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item>
                      <FormControlLabel
                        labelPlacement="end"
                        label={<Typography variant="body2">Organization Admin</Typography>}
                        control={
                          <Checkbox
                            checked={values?.isAdmin}
                            onChange={(e) => handleChange("isAdmin", e.target.checked)}
                            size="small"
                            color="primary"
                            className={classes.checkbox}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                  Choose who will be paying:
                </Typography>
                <RadioGroup row aria-label="user-payer" name="userPayer" value={values.userPayer} onChange={handleUserPayerChange}>
                  <FormControlLabel value="org" control={<Radio color="primary" size="small" />} label="Organization" />
                  <FormControlLabel value="user" control={<Radio color="primary" size="small" />} label="User" />
                </RadioGroup>
              </Grid>
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions className={classes.dialogAction}>
          <Button onClick={handleFormSubmit} variant="contained" color="primary">
            Update
          </Button>
          <Button onClick={() => closeHandler(false)} variant="contained" className={classes.actionButton}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditUser;
